import React from 'react';

const StepsSection = ({ activeStep = 1 }) => {
  const items = [
    { number: 1, text: 'Drag & drop your AAB here.' },
    { number: 2, text: 'We detect approval-blocking issues.' },
    { number: 3, text: 'We upload your app to the store.' },
    { number: 4, text: 'It\'s live – completely free.' },
  ];

  // CSS keyframes for shimmer effect
  const shimmerStyle = `
    @keyframes shimmer {
      0% {
        background-position: -200% 0;
      }
      100% {
        background-position: 200% 0;
      }
    }
  `;

  return (
    <div className="w-full pt-16 pb-24 bg-black text-white overflow-hidden">
      <style>{shimmerStyle}</style>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Container for the desktop view - Increased space-x */}
        <div className="relative hidden md:flex justify-center items-start space-x-32">
          {/* Map through items to create boxes and lines */}
          {items.map((item, index) => (
            <div key={item.number} className="relative flex flex-col items-center text-center w-32 pt-[24px]"> {/* Added pt to align text below line */}
              {/* The numbered box - positioned slightly up to align with line visually */}
              <div 
                className={`absolute top-0 w-12 h-12 flex items-center justify-center ${
                  item.number === activeStep 
                    ? 'active-step-box'
                    : 'bg-black text-white'
                } rounded-md text-xl font-medium ${
                  item.number === activeStep 
                    ? 'border-0'
                    : 'border border-gray-500'
                } z-10 shadow-lg overflow-hidden`}
                style={item.number === activeStep ? {
                  background: 'linear-gradient(135deg, #6366f1, #a855f7, #3b82f6, #6366f1)',
                  backgroundSize: '400% 100%',
                  animation: 'shimmer 3s ease-in-out infinite'
                } : {}}
              >
                {item.number}
              </div>
              {/* Conditionally render the connecting line (except for the last item) - Increased width */}
              {index < items.length - 1 && (
                <div className="absolute top-[24px] left-full w-32 h-[2px] bg-gradient-to-r from-transparent via-gray-600 to-transparent z-0"></div>
              )}
              {/* The text - positioned below the box */}
              <p className={`text-sm leading-snug mt-12 ${
                item.number === activeStep ? 'font-medium' : ''
              }`}>{item.text}</p> {/* Added mt to clear the box */}
            </div>
          ))}
        </div>

        {/* תצוגת מובייל */}
        <div className="md:hidden flex flex-col space-y-8">
          {items.map((item) => (
            <div key={item.number} className="flex items-center">
              <div 
                className={`w-12 h-12 flex items-center justify-center rounded-md text-xl font-medium flex-shrink-0 overflow-hidden ${
                  item.number === activeStep 
                    ? 'active-step-box shadow-lg'
                    : 'bg-black text-white border border-gray-500'
                }`}
                style={item.number === activeStep ? {
                  background: 'linear-gradient(135deg, #6366f1, #a855f7, #3b82f6, #6366f1)',
                  backgroundSize: '400% 100%',
                  animation: 'shimmer 3s ease-in-out infinite'
                } : {}}
              >
                {item.number}
              </div>
              <div className="ml-4">
                <p className={`text-sm leading-snug ${
                  item.number === activeStep ? 'font-medium' : ''
                }`}>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
        
        {/* קו ארוך מתחת לכל התוכן */}
        <div className="w-full mt-24 flex justify-center">
          <div className="w-full h-[2px] bg-gradient-to-r from-transparent via-gray-600 to-transparent"></div>
        </div>
      </div>
    </div>
  );
};

export default StepsSection; 